import React from "react";

import { GMNFilterProps, useGmnCheckboxInfo } from "./helpers/use-gmn-checkbox-info";
import { MultiCheckboxes } from "./multi-checkboxes";

const GmnFilterCheckboxes: React.FC<GMNFilterProps> = (props) => {
  const { unlinkedChecked, checkboxOptions, gmnIdsFilterFunction, handleUnlinkedClick } =
    useGmnCheckboxInfo(props);

  return (
    <MultiCheckboxes
      type="GMN"
      checkboxOptions={[...checkboxOptions]}
      filterFunction={gmnIdsFilterFunction}
      handleUnlinkedClick={handleUnlinkedClick}
      unlinkedChecked={unlinkedChecked}
    ></MultiCheckboxes>
  );
};

export { GmnFilterCheckboxes };
